import { MedicineContainer, PlacesContainer, PlaceItem, CheckItem, ImageSection, ImageText } from './Medicine.style'
import { FaCheck } from 'react-icons/fa'
import ProductDelivery from '../../assets/product-delivery.png'
import Message from '../../assets/message.png'
import BackgroundMision from '../../assets/MisionVision/background-mision.png'

const Medicine = () => {
    return(
        <MedicineContainer>
            <PlacesContainer>
                <PlaceItem>
                    <CheckItem>
                        <FaCheck />
                    </CheckItem>
                    <h3>20</h3>
                    <p>años</p>
                    <p>de experiencia</p>
                </PlaceItem>
                <PlaceItem>
                    <CheckItem>
                        <FaCheck />
                    </CheckItem>
                    <h3>+1,000</h3>
                    <p>medicamentos</p>
                    <p>Para diferentes afecciones a tu alcance</p>
                </PlaceItem>
                <PlaceItem>
                    <CheckItem>
                        <FaCheck />
                    </CheckItem>
                    <img src={ProductDelivery} alt='DeliveryProduct' />
                    <ImageText>Cobertura a todo el país</ImageText>
                </PlaceItem>
                <PlaceItem>
                    <CheckItem>
                        <FaCheck />
                    </CheckItem>
                    <img src={Message} alt='Message' />
                    <ImageText>Asesoría Médica Profesional</ImageText>
                </PlaceItem>
            </PlacesContainer>
            <ImageSection>
                <img src={BackgroundMision} alt='BackgroundMision' />
            </ImageSection>
        </MedicineContainer>
    )
}

export default Medicine